// extracted by mini-css-extract-plugin
export var commitInfo = "gLlg7QBl";